import api from "../libs/api";

export default {
	// getsupportDesk: (page, itemsPerPage, sortBy = '', sortOrder = '') => {
	//   return new Promise((resolve, reject) => {
	//     const queryParams = new URLSearchParams({
	//       page,
	//       itemsPerPage,
	//       sortBy,
	//       sortOrder,
	//     }).toString();

	//     api()
	//       .get(`/request-support-form?${queryParams}`)
	//       .then(({ status, data }) => {
	//         if (status === 200) {
	//           resolve(data);
	//         } else {
	//           throw new Error(`Failed with status: ${status}`);
	//         }
	//       })
	//       .catch((error) => reject(error));
	//   });
	// },

	getsupportDesk: async (params = {}) => {
		// 1. Destructure frontend-specific names (like pageSize) and collect the rest.
		const { pageSize, ...otherParams } = params;

		// 2. Build the final query parameters for the API call.
		//    This includes page, sortBy, sortOrder, and any search fields.
		const queryParams = {
			...otherParams,
		};

		// 3. Map the frontend's 'pageSize' to the backend's expected 'per_page'.
		//    This decouples your component's state from the API's specific naming.
		if (pageSize) {
			queryParams.per_page = pageSize;
		}

		// 4. (Recommended) Clean up any parameters that are null, undefined, or empty strings
		//    so they are not included in the request URL.
		Object.keys(queryParams).forEach(
			(key) =>
				(queryParams[key] === undefined ||
					queryParams[key] === null ||
					queryParams[key] === "") &&
				delete queryParams[key]
		);

		try {
			// 5. Use await to get the response. Axios automatically handles JSON parsing.
			//    The 'params' config option automatically builds the URL query string.
			const response = await api().get("/request-support-form", {
				params: queryParams,
			});

			// 6. Return the data directly. Axios will throw an error for non-2xx status
			//    codes, which will be caught by the catch block.
			return response.data;
		} catch (error) {
			// 7. Log the error for debugging and re-throw it so the component's
			//    catch block can handle it (e.g., show a notification to the user).
			console.error(
				"Error fetching support desk data:",
				error.response || error
			);
			throw error;
		}
	},

	searchSupportDesk: (fields) => {
		return new Promise((resolve, reject) => {
			const filteredFields = Object.entries(fields).filter(
				([key, value]) =>
					value !== undefined && value !== "" && typeof value !== "object"
			);
			const queryString = filteredFields
				.map(
					([key, value]) =>
						`${encodeURIComponent(key)}=${encodeURIComponent(value)}`
				)
				.join("&");

			const url = `/request-support-form?${queryString}`;

			api()
				.get(url)
				.then(({ status, data }) => {
					if (status === 200) {
						resolve(data);
					} else {
						throw new Error(`Failed with status: ${status}`);
					}
				})
				.catch((error) => reject(error));
		});
	},

	postSupportDesk: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post("request-support-form", data, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(({ status, data }) => {
					if (status === 201) {
						resolve(data);
					}
				})
				.catch((error) => reject(error));
		});
	},

	getSupportDeskById: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/request-support-form/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getEquipmentsRequestById: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/crf/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateEquipmentRequest: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`crf/${id}`, data)
				.then(({ status, data }) => {
					if (status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteCrf: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`crf/${id}`)
				.then(({ status, data }) => {
					if (status === 200) {
						resolve(data);
					}
				})
				.catch((error) => reject(error));
		});
	},
};
